module.exports = __webpack_public_path__ + "static/media/noun_test_2191650.05859afe.svg";